import { render, staticRenderFns } from "./NewsEn.vue?vue&type=template&id=c445a8aa&scoped=true&"
import script from "./NewsEn.vue?vue&type=script&lang=js&"
export * from "./NewsEn.vue?vue&type=script&lang=js&"
import style0 from "./NewsEn.vue?vue&type=style&index=0&id=c445a8aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c445a8aa",
  null
  
)

export default component.exports